import { createFileRoute, redirect } from "@tanstack/react-router";

/** Raiz de /app — vai para a home personalizada. */
export const Route = createFileRoute("/app/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/inicio" });
  },
});
